export function numValidator(value) {
  return !isNaN(value);
}



// WEBPACK FOOTER //
// ./src/app/utils/validator.js